'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EntryNames = exports.EntryNames = {
  framework: 'percy_framework',
  render: 'percy_render',
  snapshots: 'percy_snapshots'
};

var GlobalVariables = exports.GlobalVariables = {
  rootSuite: '__PERCY_ROOT_SUITE__'
};

var RootElementId = exports.RootElementId = 'percy-root';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-webpack/lib/entry/constants.js
// module id = 495
// module chunks = 1